import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getPlant, resetClassifyImage } from '../../actions'

import { FillerDiv, CenteredDiv } from '../StyledComponents/Fillers'
import {
    SliderContainer,
    ImageSlider,
    PlantDetailsImage,
    PlantDetailsImageShadow,
    PlantDetailsHeader,
    PlantName,
    PlantLatinName,
    PlantActionsContainer,
    PlantActionsButton
} from '../StyledComponents/Plants/PlantDetails'
import PlantTabContainer from '../Plant/PlantTabContainer'
import LoadingSpinner from '../Global/LoadingSpinner'

class PlantDetailsPage extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
        this.props.getPlant(this.props.match.params.id)
    }

    componentWillUnmount() {
        this.props.resetClassifyImage()
    }

    render() {
        const { plants, match, classifier } = this.props

        const plant = plants ? plants[match.params.id] : null

        if (!plant) {
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        const sliderSettings = {
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        }

        const showActions = false
        const plantActions = showActions ? (
            <PlantActionsContainer>
                <PlantActionsButton color="info">Add to sensor</PlantActionsButton>
                <PlantActionsButton color="info">Is not this plant</PlantActionsButton>
            </PlantActionsContainer>
        ) : null

        const classifierImage = classifier && classifier.image
            ? <PlantDetailsImage imageWidth={window.innerWidth} src={classifier.image} />
            : null

        return (
            <FillerDiv>
                <SliderContainer>
                    <ImageSlider {...sliderSettings}>
                        <PlantDetailsImage imageWidth={window.innerWidth} src={plant.image} />
                        {classifierImage}
                    </ImageSlider>
                    <PlantDetailsImageShadow />
                </SliderContainer>
                <PlantDetailsHeader>
                    <PlantName>{plant.localized_name}</PlantName>
                    <PlantLatinName>{plant.name}</PlantLatinName>
                    {plantActions}
                    <PlantTabContainer plant={plant} />
                </PlantDetailsHeader>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    plants: state.plants,
    classifier: state.classifier,
})

export default connect(mapStateToProps, { getPlant, resetClassifyImage })(PlantDetailsPage)



// WEBPACK FOOTER //
// ./src/components/pages/PlantDetails.js